import React, { useEffect } from 'react';
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';
import { usePantallas } from '../context/PantallasContext';
import { PANTALLA_SIN_REGISTRAR, PANTALLA_VISIBLE } from '../utils/pantallas';

// Sustituye al <Outlet /> de los layouts: pide la visibilidad al backend en
// cada pantalla y, si la actual está oculta para el rol, muestra un aviso en
// vez del contenido. Una pantalla que no está en la tabla (nueva, sin dar de
// alta) se tapa con un mensaje distinto.
export default function GuardaPantalla({ inicio = '/jornadas', children }) {
  const { pathname } = useLocation();
  const { cargado, recargar, estado } = usePantallas();

  useEffect(() => { recargar(); }, [pathname, recargar]);

  if (!cargado) return null;
  const estadoActual = estado(pathname);
  if (estadoActual !== PANTALLA_VISIBLE) {
    // El login (único uso con children) oculto al público: se manda al inicio
    // en vez de enseñar el aviso. /jornadas no usa children, así que no hay bucle.
    if (children) return <Navigate to={inicio} replace />;
    const sinRegistrar = estadoActual === PANTALLA_SIN_REGISTRAR;
    return (
      <div className="pantalla-oculta" role="status">
        <h2>Pantalla no disponible</h2>
        <p>{sinRegistrar
          ? 'Esta pantalla no es visible. Contacte con el administrador.'
          : 'Esta pantalla no está disponible ahora mismo.'}</p>
        <Link to={inicio}>Volver al inicio</Link>
      </div>
    );
  }
  return children ?? <Outlet />;
}
